<template>
  <Card class="text-center flex flex-col gap-4" v-if="!posts || posts?.length">
    <h1 class="text-lg font-bold tracking-wide">Access Exclusive Posts</h1>
    <slot name="description" v-if="description || $slots.description">
      <p class="text-sm sm:text-base">{{ description }}</p>
    </slot>

    <!--    TODO: incorperate data-->
    <div
      v-if="posts || true"
      class="mt-auto group overflow-hidden rounded-lg aspect-video select-none flex items-center justify-center gap-4"
      :class="{
        subscribe: subscribeLink,
        'stage-gradient-nami': !subscribeLink,
        'stage-gradient-yellow': subscribeLink,
      }"
      @click="showAll = true"
    >
      <!--      <TitleDisplayCoverTitle-->
      <!--        v-for="title in posts.slice(0, 3)"-->
      <!--        class="w-[25%] drama-3"-->
      <!--        :class="{-->
      <!--          'drama-yellow-400': subscribeLink,-->
      <!--          'drama-nami-nami-blue': !subscribeLink,-->
      <!--        }"-->
      <!--        :title="title"-->
      <!--        hide-title-->
      <!--      />-->
      <div
        class="w-[70%] p-[2%] bg-white dark:bg-neutral-800 aspect-video rounded-xl flex flex-col"
      >
        <div class="flex gap-[2%] relative">
          <AsyncImage
            class="w-[15%] border rounded-full aspect-square bg-neutral-300 dark:bg-neutral-700 flex-shrink-0"
            :src="
              org
                ? getOrganizationAvatar(org)
                : '/assets/nami/profile/sea-deity.png'
            "
          />
          <div
            class="truncate text-left font-bold text-sm lg:text-base my-auto w-[83%]"
          >
            {{ org?.attributes.name }}
          </div>
        </div>
        <NamiDivider class="!my-[3%]" />
        <div
          class="bg-neutral-300 dark:bg-neutral-700 rounded-lg flex-grow"
        ></div>
      </div>
    </div>
  </Card>
</template>

<script setup lang="ts">
import {
  getOrganizationAvatar,
  type OrganizationEntity,
  type PostEntity,
} from "~/src/api";

defineProps<{
  org?: OrganizationEntity;
  posts?: PostEntity[] | false | null;
  subscribeLink?: string;
  description?: string;
}>();

const showAll = ref(false);
</script>
